import React from 'react';
import { musicKeyIcon } from '@chordbaker/design';

interface MusicKeyIconProps {
  className?: string;
}

const MusicKeyIcon: React.FC<MusicKeyIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={musicKeyIcon.viewBox}
      fill={musicKeyIcon.fill}
      className={className}
      style={{ transform: 'scale(0.8)' }}
    >
      <path d={(musicKeyIcon.elements[0] as { d: string }).d} />
    </svg>
  );
};

export default MusicKeyIcon;
